import { Injectable } from '@angular/core';
import { NavigationService } from '@vex/services/navigation.service';
@Injectable({
  providedIn: 'root'
})
export class BreadcrumbsService {
  constructor(
    private navigationService: NavigationService
  ) {
  }

  getBreadcrumbs(basePath) {
    return new Promise((resolve) => {
      let attempts = 0;
      let maxAttempts = 25;
      let checkBreadcrumbs = setInterval(() => {
        attempts++;
        let breadCrumb = this.navigationService.getBreadcrumbs().find((d) => d.PageId === basePath);
        if (breadCrumb) {
          clearInterval(checkBreadcrumbs);
          checkBreadcrumbs = null;
          resolve(breadCrumb);
        }
        if (attempts >= maxAttempts) {
          clearInterval(checkBreadcrumbs);
          checkBreadcrumbs = null;
          resolve({});
        }
      }, 500);
    });
  }

  getWizardBreadcrumbs(basePath: string): Promise<any[]> {
    return new Promise((resolve) => {
      let attempts = 0;
      let maxAttempts = 25;
      let checkBreadcrumbs = setInterval(() => {
        attempts++;
        let breadcrumb = this.navigationService.getBreadcrumbs().find((d) => d.PageId === basePath);
        if (breadcrumb && breadcrumb.Crumbs) {
          let crumbs = breadcrumb.Crumbs.map((label, index) => {
            let navigatePath = breadcrumb.Navigate[index];
            let isRelative = navigatePath && navigatePath.includes('./');
            let value = isRelative ? '' : navigatePath;

            return {
              Label: label,
              Value: value
            };
          });
          clearInterval(checkBreadcrumbs);
          checkBreadcrumbs = null;
          resolve(crumbs);
        }
        if (attempts >= maxAttempts) {
          clearInterval(checkBreadcrumbs);
          checkBreadcrumbs = null;
          resolve([]);
        }
      }, 100);
    });
  }
}
